import { ThemeProvider, createMuiTheme } from "@material-ui/core";
import React from "react";

const ThemeProviderComponent: React.FC = ({ children }) => {
  const theme = createMuiTheme({
    palette: {
      primary: {
        main: "#727cf5",
        dark: "#464F6D",
        light: "rgba(114, 124, 245,0.8)",
      },
      secondary: {
        main: "#121C2E",
        dark: "rgb(14, 23, 38)",
        light: "#464f5b",
      },
      success: {
        main: "#0acf97",
        "100": "rgba(10,207,151,.18)",
      },
      text: {
        secondary: "#fff",
        disabled: "#aab8c5",
      },
    },
    typography: {
      fontFamily: [
        "Nunito",
        "Roboto",
        '"Helvetica Neue"',
        "Arial",
        "sans-serif",
      ].join(","),
    },
  });
  return <ThemeProvider theme={theme}>{children}</ThemeProvider>;
};

export default ThemeProviderComponent;
